import { useEffect, useMemo, useState } from "react"
import "../../../styles/themes.css"
import "../../../styles/bill.css"
import * as TrinityAPI from "../../../requests/TrinityAPI"
import { useParams } from "react-router-dom"
import { getFormattedDate, spacedNum } from "../../common/CommonHelper"
import { IClientRequestDto } from "../../../types/request/IClientRequestDto"
import { getStorageUrl } from "@/lib/helper"
import { ICurrencyReplenishmentDto } from "@/types/replenishment/ICurrencyReplenishmentDto"

import style from "./style.module.scss"
import clsx from "clsx"
import { ICompanyBank } from "@/types/company/IFullCompanyDto"

export const CurrencyBill = () => {
  const params = useParams()
  const [replenishment, setReplenishment] = useState<ICurrencyReplenishmentDto>()
  const [clientRequest, setClientRequest] = useState<IClientRequestDto>()

  const company = clientRequest?.company
  const payer = clientRequest?.currencyPayer

  const bankInfo: ICompanyBank | null = useMemo(() => {
    if (!clientRequest?.companyBankId) return null

    return company?.banksRef?.find(b => Number(b.id) === Number(clientRequest?.companyBankId)) || null
  }, [clientRequest])

  useEffect(() => {
    if (!params.id) return
    TrinityAPI.getCurrencyReplenishment(Number(params.id), response => {
      if (response.status === 200) {
        setReplenishment(response.data)
      } else {
        alert("Счет не найден")
      }
    })
  }, [])

  useEffect(() => {
    if (replenishment?.clientCurrencyRequestId) {
      TrinityAPI.getClientCurrencyRequest(Number(replenishment?.clientCurrencyRequestId), response => {
        if (response.status === 200) {
          setClientRequest(response.data)
        }
      })
    }
  }, [replenishment])

  useEffect(() => {
    if (replenishment && clientRequest && company && payer) {
      setTimeout(() => window.print(), 1000)
    }
  }, [replenishment, clientRequest])

  if (replenishment && clientRequest) {
    return (
      <div className="container-schet" style={{ backgroundColor: "white", height: "auto" }}>
        <div className="paper" style={{ width: "21cm" }}>
          <div className={style.header}>
            <div>{company?.name}</div>
            <img src={`${getStorageUrl()}/${company?.logoPath}`} alt="logo" className="legal-img-sign" />
          </div>

          <div className={style.invoice}>
            <p className={style.first}>invoice</p>
            <p className={style.number}>
              N: {replenishment?.id}
              {company?.shortName}
            </p>
          </div>

          <div className={style.date}>
            <p>
              Date: <span>{getFormattedDate(replenishment?.createdAt || new Date().toString())}</span>
            </p>
          </div>

          <div className={style.payInfo}>
            <div>
              <div className={style.bold}>Principal:</div>
              <div className={style.bold}>{payer?.name}</div>
              <div>{payer?.address}</div>
            </div>
            <div>
              <div className={style.bold}>Payment agent:</div>
              <div className={style.bold}>{company?.name}</div>
              <div>{company?.address}</div>
            </div>
          </div>

          <div className={style.currency}>
            <div>Currency:</div>
            <div>{clientRequest?.currency}</div>
          </div>

          <div className={style.table}>
            <div className={clsx(style.row, style.headerRow)}>
              <div>No</div>
              <div>Description</div>
              <div>Quantity</div>
              <div>Unit</div>
              <div>Unit price</div>
              <div>Total amount</div>
            </div>
            <div className={style.row}>
              <div>1</div>
              <div>Services according to Agency Contract №{replenishment?.contractNumber}</div>
              <div>1</div>
              <div>n/a</div>
              <div>
                {replenishment?.invoiceAmount
                  ? spacedNum(Number(replenishment?.invoiceAmount) / 100).replace(".", ",")
                  : ""}
              </div>
              <div>
                {replenishment?.invoiceAmount
                  ? spacedNum(Number(replenishment?.invoiceAmount) / 100).replace(".", ",")
                  : ""}
              </div>
            </div>
            <div className={clsx(style.row, style.footerRow)}>
              <div />
              <div>Total all</div>
              <div>1,00</div>
              <div />
              <div />
              <div>
                {replenishment?.invoiceAmount
                  ? spacedNum(Number(replenishment?.invoiceAmount) / 100).replace(".", ",")
                  : ""}
              </div>
            </div>
          </div>

          <div className={style.companyData}>
            <div>Company name: {company?.name}</div>
            <div>Company address: {company?.address}</div>
            <div className={style.red}>Bank name: {bankInfo?.name}</div>
            <div className={style.red}>SWIFT: {bankInfo?.swift}</div>
            <div className={style.red}>Account number (AED): {bankInfo?.accountNumber}</div>
          </div>

          <div className={style.legal}>
            <div className={style.terms}>
              <div className={style.termsItem}>
                <div>Terms of delivery:</div>
                <div>Goods and services do not pass custom border of Indonesia</div>
              </div>
              <div className={style.termsItem}>
                <div>Terms of payment:</div>
                <div>Within 180 days from date of invoice</div>
              </div>
              <div className={style.termsItem}>
                <div>Payment agent comission:</div>
                <div>As indicated in Agency Contract</div>
              </div>
            </div>

            <div className={style.legalInfo}>
              <div className={style.legalTitle}>{company?.name}</div>
              <div className={style.legalImgs}>
                <img src={`${getStorageUrl()}/${company?.signPath}`} alt="sign" />
                <img src={`${getStorageUrl()}/${company?.stampPath}`} alt="stamp" />
              </div>
              <div>
                <div className={style.legalName}>{company?.personName}</div>
                <div className={style.legalPosition}>{company?.personPosition}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  } else {
    return (
      <div className="container-schet">
        <div className="paper">Формируем...</div>
      </div>
    )
  }
}
